import { Icon, Stack, Text } from '@chakra-ui/react';
import { MailIcon } from '@heroicons/react/outline';
import { useTranslations } from 'use-intl';

export function InvitationsTableEmpty(): JSX.Element {
  const i18nInvitationsTableEmpty = useTranslations('Invitations.TableEmpty');

  return (
    <Stack layerStyle="emptyState">
      <Icon as={MailIcon} boxSize="40px" color="gray.500" />
      <Text>{i18nInvitationsTableEmpty('NoInvitations')}</Text>
    </Stack>
  );
}
